import React from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import FacilitiesExplorePage from './facilitiesExplorePage';
import FacilitiesLayoutPage from './facilitiesLayoutPage';
import { getFacilitiesResponse } from '../../../../api/licence';
import { setFacilitiesResponse } from '../../../../redux/reducers/licenceAnalytics';

interface FacilitiesPageProps {
  mode: string;
}

const FacilitiesPage: React.FC<FacilitiesPageProps> = React.memo(({ mode }) => {
  const dispatch = useDispatch();
  const { data: facilityResponse = [] }:any = useQuery('facility', getFacilitiesResponse);
  const facilityWithoutTraining = facilityResponse.filter((facility:any) => facility?.club?.league?.id != 2011);
  dispatch(setFacilitiesResponse({ response: facilityWithoutTraining }));

  return <>{mode === 'Dashboard' ? <FacilitiesLayoutPage /> : <FacilitiesExplorePage />}</>;
});

export default FacilitiesPage;
